namespace GeniuzPOS.Product {
    export class CsSubCategory2Columns {
        static columnsKey = 'Product.CsSubCategory2';
    }
}
